const headersTitles = [
    "Fecha",
    "Tipo de Transacción",
    "Descripción",
    "Ingreso(Bs.)",
    "Egreso(Bs.)",
    "Saldo(Bs.)"
];

module.exports = {
    headersTitles
};



// WEBPACK FOOTER //
// ./src/views/AccountStatus/AccountStatusVariables.js